import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X, LogOut, LayoutDashboard, User2, ShieldCheck } from 'lucide-react';
import Logo from './Logo';
import { useAuth } from '@/contexts/AuthContext';

const linkBase = 'text-sm text-zinc-400 hover:text-white transition-colors px-3 py-1.5 rounded-md';
const linkActive = 'text-white';

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const onLogout = async () => { await logout(); nav('/'); };

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 bg-black/70 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <Logo size={26} />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/plans" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ''}`} data-testid="nav-plans">Plans</NavLink>
          <NavLink to="/rules" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ''}`} data-testid="nav-rules">Rules</NavLink>
          <NavLink to="/about" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ''}`} data-testid="nav-about">About</NavLink>
          <NavLink to="/faq" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ''}`} data-testid="nav-faq">FAQ</NavLink>
          <a href="https://t.me/tradersspringgroup" target="_blank" rel="noreferrer" className={linkBase} data-testid="nav-support">Support</a>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {user.role === 'admin' && (
                <Link to="/admin" className="btn-ghost btn-sm" data-testid="nav-admin">
                  <ShieldCheck size={14} className="inline mr-1" /> Admin
                </Link>
              )}
              <Link to="/dashboard" className="btn-ghost btn-sm" data-testid="nav-dashboard">
                <LayoutDashboard size={14} className="inline mr-1.5" /> Dashboard
              </Link>
              <button onClick={onLogout} className="btn-ghost btn-sm" data-testid="nav-logout">
                <LogOut size={14} className="inline mr-1.5" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost btn-sm" data-testid="nav-login">Sign in</Link>
              <Link to="/register" className="btn-primary btn-sm" data-testid="nav-register">Start Evaluation →</Link>
            </>
          )}
        </div>

        <button className="md:hidden text-zinc-300" onClick={() => setOpen(v => !v)} data-testid="nav-mobile-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-black/95">
          <div className="p-4 flex flex-col gap-1">
            <Link to="/plans" className={linkBase} onClick={() => setOpen(false)} data-testid="mnav-plans">Plans</Link>
            <Link to="/rules" className={linkBase} onClick={() => setOpen(false)} data-testid="mnav-rules">Rules</Link>
            <Link to="/about" className={linkBase} onClick={() => setOpen(false)} data-testid="mnav-about">About</Link>
            <Link to="/faq" className={linkBase} onClick={() => setOpen(false)} data-testid="mnav-faq">FAQ</Link>
            <a href="https://t.me/tradersspringgroup" target="_blank" rel="noreferrer" className={linkBase} data-testid="mnav-support">Support</a>
            <div className="h-px bg-white/5 my-2" />
            {user ? (
              <>
                {user.role === 'admin' && <Link to="/admin" className="btn-ghost btn-sm" data-testid="mnav-admin">Admin</Link>}
                <Link to="/dashboard" className="btn-ghost btn-sm" data-testid="mnav-dashboard">Dashboard</Link>
                <button onClick={onLogout} className="btn-ghost btn-sm text-left" data-testid="mnav-logout">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn-ghost btn-sm" data-testid="mnav-login">Sign in</Link>
                <Link to="/register" className="btn-primary btn-sm" data-testid="mnav-register">Start Evaluation</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
